import { getInitials, getAvatarColor } from '@/utils/stringUtils';

interface AvatarDisplayProps {
  name: string;
  picture?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'w-8 h-8 text-sm',
  md: 'w-10 h-10 text-base',
  lg: 'w-12 h-12 text-lg',
};

export function AvatarDisplay({ name, picture, size = 'md' }: AvatarDisplayProps) {
  const initial = name ? getInitials(name) : '?';
  const colorClass = getAvatarColor(name);

  if (picture) {
    return (
      <div className={`${sizeClasses[size]} shrink-0 overflow-hidden rounded-full`}>
        <img src={picture} alt={name} className="size-full object-cover" />
      </div>
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} ${colorClass} flex shrink-0 items-center justify-center rounded-full font-semibold text-white`}
    >
      {initial}
    </div>
  );
}
